module.exports = __webpack_public_path__ + "img/team_position.e957a727.png";